import { BasePage } from '@/components/ui/base-page'
import { Outlet, useOutletContext } from 'react-router-dom'
import { BreadcrumbItem } from '@/components/ui/breadcrumb-nav'

type OutletContextType = {
  parentBreadcrumbs: BreadcrumbItem[]
}

export function SoftwarePage() {
  const breadcrumbs: BreadcrumbItem[] = [
    {
      label: "Software & Technology",
      description: "Innovative software solutions and technology platforms",
      href: "/software"
    }
  ]

  return (
    <BasePage>
      <Outlet context={{ parentBreadcrumbs: breadcrumbs }} />
    </BasePage>
  )
}

export function useSoftwareContext() {
  return useOutletContext<OutletContextType>()
}